import React from "react";
import ResetPasswordLayer from "../components/ResetPasswordLayer";

const ResetPasswordPage = () => {
  return (
    <>
      <ResetPasswordLayer />
    </>
  );
};

export default ResetPasswordPage;